var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages"},_vm._l((_vm.messages),function(message){return _c('div',{key:message.id,staticClass:"message",on:{"click":function($event){$event.preventDefault();return _vm.remove(message.id)}}},[_vm._v(" "+_vm._s(message.message)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }